export const environment = {
  production: false,
  
  // AWS Cognito Configuration
  cognito: {
    userPoolId: 'ap-southeast-2_aQiXRw0dy',
    userPoolWebClientId: '335j2pgp713go6ec1k80l6octm',
    region: 'ap-southeast-2',
  },
  
  // API Configuration
  api: {
    baseUrl: 'https://suppliers-dev.winning.com.au/supplier'
  },
  
  // Cognito OAuth Configuration
  cognitoOAuth: {
    clientId: '1c5pprrc7hc27nj3ie3bcjjj6g',
    redirectUri: 'https://suppliers-dev.winning.com.au/login/callback',
    domain: 'https://winnsdhdomain.auth.ap-southeast-2.amazoncognito.com'
  },

  hmac : {
    key : "",
    secretName: 'winn-sdh-apse2-dev-hmac-sm',
  }
};